module.exports = __webpack_public_path__ + "static/media/iconQuestionMark.1da6b299.svg";